/* index.tsx generated by @compiled/babel-plugin v0.38.1 */
import _extends from "@babel/runtime/helpers/extends";
import "./index.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box } from '@atlaskit/primitives/compiled';
import Select, { components } from '@atlaskit/select';
import { getInputAccessibilityDescriptionId } from '../../common/accessibilityUtils';
import { getDropDownMenuPosition } from '../../common/commonDropDownMenuProps';
import { messages } from './messages';
var styles = {
  container: "_1e0c1txw _2lx2vrvc",
  parent: "_1bsb1ssb _2hwxu2gc",
  child: "_1bsb1ssb"
};
var menuStyles = {
  menu: "_1pbyni7l"
};
export var EditCascadingDropdown = function EditCascadingDropdown(_ref) {
  var id = _ref.id,
    errorId = _ref.errorId,
    options = _ref.options,
    value = _ref.value,
    childOptions = _ref.childOptions,
    childValue = _ref.childValue,
    loading = _ref.loading,
    isInvalid = _ref.isInvalid,
    onChange = _ref.onChange,
    onChangeChild = _ref.onChangeChild,
    isRequired = _ref.isRequired,
    label = _ref.label,
    descriptionId = _ref.descriptionId;
  return /*#__PURE__*/React.createElement(Box, {
    xcss: styles.container
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: styles.parent
  }, /*#__PURE__*/React.createElement(EditDropdown, {
    id: id,
    errorId: errorId,
    descriptionId: descriptionId,
    options: options,
    value: value !== null && value !== void 0 ? value : null,
    loading: loading,
    isInvalid: isInvalid,
    onChange: onChange,
    clearable: true,
    isRequired: isRequired,
    label: label
  })), /*#__PURE__*/React.createElement(Box, {
    xcss: styles.child
  }, /*#__PURE__*/React.createElement(EditDropdown, {
    id: "".concat(id, "-child"),
    errorId: errorId,
    descriptionId: descriptionId,
    options: childOptions,
    value: childValue !== null && childValue !== void 0 ? childValue : null,
    loading: loading,
    isInvalid: isInvalid,
    onChange: onChangeChild,
    isRequired: isRequired,
    label: label
  })));
};
var EditDropdown = function EditDropdown(_ref2) {
  var id = _ref2.id,
    errorId = _ref2.errorId,
    options = _ref2.options,
    value = _ref2.value,
    loading = _ref2.loading,
    isInvalid = _ref2.isInvalid,
    onChange = _ref2.onChange,
    _ref2$clearable = _ref2.clearable,
    clearable = _ref2$clearable === void 0 ? false : _ref2$clearable,
    label = _ref2.label,
    descriptionId = _ref2.descriptionId;
  return /*#__PURE__*/React.createElement(Select, _extends({
    inputId: fg('jsm-accessibility-fixes') ? id : undefined,
    id: fg('jsm-accessibility-fixes') ? undefined : id,
    key: id,
    descriptionId: fg('jsm-accessibility-fixes') ? getInputAccessibilityDescriptionId(errorId, descriptionId, isInvalid) : undefined,
    options: options,
    value: value !== null && value !== void 0 ? value : null,
    isLoading: loading,
    onChange: onChange,
    isSearchable: true,
    isClearable: clearable,
    noOptionsMessage: function noOptionsMessage() {
      return /*#__PURE__*/React.createElement(FormattedMessage, messages.choiceDropdownNoOptions);
    },
    placeholder: /*#__PURE__*/React.createElement(FormattedMessage, messages.choiceDropdownSelect)
  }, getDropDownMenuPosition(), {
    label: label
  }, fg('jsm-request-intake-jac-fixes') ? {
    components: {
      Menu: function Menu(props) {
        return /*#__PURE__*/React.createElement(components.Menu, _extends({}, props, {
          xcss: menuStyles.menu
        }));
      }
    }
  } : {}));
};